import React from 'react';

/**
 * Tiny colour legend that sits directly under a Pollen Dots Leaflet map.
 * Keeps the atlas readable at world zoom where the rose/gold markers would
 * otherwise be swamped by hundreds of teal place pins. Colours MUST stay in
 * sync with ROLE_STYLE in PollenDotsMap.jsx.
 *
 * Pass `items` to override the default 4-chip set (e.g., vendor share pages
 * show only Places because guides/drivers don't relate to hotels).
 */
const DEFAULT_ITEMS = [
  { color: '#0d9488', label: 'Places',  testid: 'legend-places' },
  { color: '#2563eb', label: 'Hotels',  testid: 'legend-hotels' },
  { color: '#e11d48', label: 'Guides',  testid: 'legend-guides' },
  { color: '#eab308', label: 'Drivers', testid: 'legend-drivers' },
];

const PollenDotsLegend = ({ items }) => {
  const list = items || DEFAULT_ITEMS;
  if (!list.length) return null;
  return (
  <div
    className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] text-muted-foreground"
    data-testid="pollen-dots-legend"
  >
    {list.map(i => (
      <span key={i.label} className="inline-flex items-center gap-1.5" data-testid={i.testid}>
        <span
          aria-hidden
          className="inline-block w-2.5 h-2.5 rounded-full ring-2 ring-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)]"
          style={{ background: i.color }}
        />
        <span>{i.label}</span>
      </span>
    ))}
  </div>
  );
};

export default PollenDotsLegend;
